import {GridColDef} from '@mui/x-data-grid';
import {ICompany} from '../../../../shared/types/company.types';
import DeleteCell from './DeleteCell';

export const columns: GridColDef<ICompany>[] = [
  {
    field: 'fullCompanyName',
    headerName: 'Полное название компании',
  },
  {
    field: 'inn',
    headerName: 'ИНН',
  },
  {
    field: 'ogrn',
    headerName: 'ОГРН',
  },
  {
    field: 'description',
    headerName: 'Комментарий',
  },
  {
    field: 'action',
    headerName: '',
    width: 40,
    renderCell: ({row}) => <DeleteCell row={row} />,
  },
];
